function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.849,5.734c-.3-1.01-1.644-1.82-4.553-1.07-1.654.43-3.088.81-3.7.97L9.912,1.394a2.608,2.608,0,0,0-2.321-.4l-.379.11a1,1,0,0,0-.667.63,1.034,1.034,0,0,0,.07.92l2.7,4.66L4.841,8.564a.984.984,0,0,1-.787-.11L2.082,7.2a1.435,1.435,0,0,0-1.225-.15l-.13.04a1.092,1.092,0,0,0-.677.68,1.074,1.074,0,0,0,.149.95l1.972,2.74a3.818,3.818,0,0,0,3.088,1.57,3.589,3.589,0,0,0,.976-.13c.04-.007,1.435-.376,3.373-.892l-.863,2.5a1.062,1.062,0,0,0,1,1.411,1.039,1.039,0,0,0,.234-.027l.266-.061a3.012,3.012,0,0,0,1.695-1.067l3.411-4.294c2.02-.544,3.919-1.061,5.129-1.4A5,5,0,0,0,23.659,7.1,1.813,1.813,0,0,0,23.849,5.734ZM10.9,13.934a1.676,1.676,0,0,1-.719.526L11.2,11.588l1.978-.529Zm11.6-7.48c-.13.23-.618.84-2.371,1.33C16.377,8.834,6,11.584,5.9,11.614a2.457,2.457,0,0,1-2.64-.94L1.733,8.564l1.614,1.02a2.281,2.281,0,0,0,1.853.27,52.308,52.308,0,0,0,5.472-1.681.608.608,0,0,0,.226-.779L7.94,2.284l.04-.01a1.248,1.248,0,0,1,1.136.2L15.062,6.9a.672.672,0,0,0,.568.11s3.7-.97,3.995-1.05c2.022-.52,2.859-.12,2.939.15A.458.458,0,0,1,22.494,6.454Z",
  transform: "translate(0.092 -0.877)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.437,18.649H4.707a.648.648,0,1,0,0,1.3h12.73a.648.648,0,0,0,0-1.3Z",
  transform: "translate(0.055 -0.978)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M13.286,22.7H.557a.649.649,0,1,0,0,1.3H13.286a.649.649,0,1,0,0-1.3Z",
  transform: "translate(0.092 -1)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/plane.4da07fd6.svg";
export { SvgComponent as ReactComponent };